import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "relative" };
import { ref, onMounted, onUnmounted, computed } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'OrSubtitles',
    setup(__props) {
        const subtitles = [
            'login.login.Empower every conversation',
            'login.login.Conversations reimagined',
            'login.login.Unleash the power of conversation',
            'login.login.Create, Communicate, Empower',
            'login.login.Define the future of conversation',
            'login.login.Beyond words their vision',
        ];
        const currentIndex = ref(0);
        const currentSubtitle = computed(() => subtitles[currentIndex.value]);
        const pickRandomSubtitle = () => {
            currentIndex.value = Math.floor((Math.random() * subtitles.length));
        };
        const pickNextSubtitle = () => {
            const length = subtitles.length;
            if (currentIndex.value === length - 1) {
                currentIndex.value = 0;
            }
            else {
                currentIndex.value++;
            }
        };
        let interval;
        pickRandomSubtitle();
        onMounted(() => {
            interval = setInterval(pickNextSubtitle, 5000);
        });
        onUnmounted(() => {
            clearInterval(interval);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_Transition, {
                    name: "fade",
                    mode: "out-in"
                }, {
                    default: _withCtx(() => [
                        (_openBlock(), _createElementBlock("div", { key: currentIndex.value }, _toDisplayString(_ctx.$t(currentSubtitle.value)), 1))
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
